import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconRectangles: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <rect x="4" y="5" width="6" height="6" rx="1" fill={fill || '#200E32'} />
      <rect x="4" y="14" width="6" height="6" rx="1" fill={fill || '#200E32'} />
      <rect x="14" y="5" width="6" height="6" rx="1" fill={fill || '#200E32'} />
      <rect
        x="14"
        y="14"
        width="6"
        height="6"
        rx="1"
        fill={fill || '#200E32'}
      />
    </Icon>
  );
};

export default IconRectangles;
